import React from 'react';
import { Link } from 'react-router-dom';
import { findMyLock, hub } from '../../content/shopContent';
import { Breadcrumbs, PageHero } from '../../components/shop/ShopBits';
import LockWizard from '../../components/shop/LockWizard';
import usePageMeta from '../../hooks/usePageMeta';

// /shop/find-my-lock — the door-first walk-through across every brand we carry: up to three
// quick questions with pictures (one for a ranchslider), then our pick and the locks that fit. The shop home
// sends people here (Hugh, 17 Sep 2026: the tool is the feature, not the front page).
const FindMyLock = () => {
  usePageMeta();
  return (
    <div className="min-h-screen bg-white">
      <PageHero title={findMyLock.h1} sub="A few quick taps about your door, with pictures — one tap for a ranchslider. Our pick and the locks that also fit, with the price fitted in Auckland or shipped anywhere in NZ." />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
        <Breadcrumbs crumbs={[{ name: 'Home', path: '/' }, { name: 'Shop', path: '/shop' }, { name: 'Find my lock' }]} />
        <LockWizard testId="find-my-lock" />
        <details className="mt-10 max-w-3xl">
          <summary className="cursor-pointer text-lg font-bold text-gray-900 select-none">Digital lock or smart lock?</summary>
          <p className="text-gray-700 mt-3">{hub.words.digital}</p>
          <p className="text-gray-700 mt-2">{hub.words.smart}</p>
          <p className="text-gray-700 mt-2">{hub.words.which}</p>
        </details>
        <div className="flex flex-wrap gap-3 text-sm mt-6">
          <Link to="/shop/e-lok" className="border border-gray-300 rounded-full px-4 py-2 text-gray-800 hover:border-gray-500">E-LOK range</Link>
          <Link to="/shop/aqara" className="border border-gray-300 rounded-full px-4 py-2 text-gray-800 hover:border-gray-500">Aqara range</Link>
          <Link to="/shop/how-to-measure" className="border border-gray-300 rounded-full px-4 py-2 text-gray-800 hover:border-gray-500">How to measure the backset</Link>
        </div>
      </div>
    </div>
  );
};

export default FindMyLock;
